<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0"><?=( image.isNew() ? "Ajouter une photo" : "Modifier la photo" )?></p>
</div>
<div class="p-3 text-center bb">
	<p>
		<a href="#<?=pond.toUrl('pond/view')?>" class="badge badge-dark badge-lg fw-400 mr-1">Mare #<span class="pond_id"><?=pond.toFixed( 'id', 0 )?></span></a>
		<span class="badge badge-<?=pond.getStatus().color?> badge-lg fw-400"><?=pond.getStatus().name?></span>
	</p>

	<? if( !image.isNew() ) { ?>
		<p class="text-center mb-0">Photo du <?=image.getDate('date')?></p>
		<? if( image.has('user_name') ) { ?>
			<p class="text-center text-secondary small mb-0">par <?=image.get('user_name')?></p>
		<? } ?>
	<? } ?>
</div>

<div class="p-3 bg-light bb">
	<? if( image.isNew() ) { ?>
		<p class="small uc text-center text-secondary mb-0">Ajout d'une photo à la mare</p>
	<? } else { ?>
		<p class="small uc text-center text-secondary mb-0">Photo envoyée le <?=image.getDate('updated_at')?></p>
	<? } ?>
</div>

<form novalidate>
	<?-image.getFormError()?>
	<div class="list-group list-group-flush">
		<div class="list-group-item">

			<? if( image.isNew() ) { ?>

				<div class="mb-3"><?-image.toHTML('span')?></div>

				<div class="row mb-3 js-file-change">
					<div class="col">
						<button type="button" class="js-open-library btn btn-dark"><i class="fa fa-th-large"></i> Choisir</button>
						<!-- <label class="btn btn-dark"><i class="fa fa-th-large"></i> Choisir<input type="file" accept="image/*" style="display:none" /></label> -->
					</div>
					<div class="col text-right">
						<button type="button" class="js-take-picture btn btn-dark"><i class="fa fa-camera"></i> Prendre</button>
						<!-- <label class="btn btn-dark"><i class="fa fa-camera"></i> B<input type="file" accept="image/*" style="display:none" capture /></label> -->
					</div>
				</div>

				<? // image.getFieldInput( 'name', { type: 'file', accept: 'image/*', class: 'd-none' } )?>
				<?-image.getFieldError( 'name' )?>
				<?-image.getFieldError( 'data' )?>
				<?-image.getFieldError( 'file' )?>

			<? } else { ?>

				<div class="mb-3">
					<em class="small text-muted">Vous ne pouvez pas modifier l'image</em>
					<?-image.toHTML()?>
				</div>

			<? } ?>

			<div class="mb-3">
				<?-image.getFormField( 'date', 'Date de prise', { type: 'date', placeholder: 'Obligatoire' }, { class: 'is-required' } )?>
			</div>
			<div class="mb-3">
				<?-image.getFormField( 'status', 'Identification de libellule', { type: 'select', choices: image.getChoices() }, { class: 'is-required' } )?>
			</div>
			<div class="mb-3">
				<?-image.getFormField( 'legend', 'Description de la photo', { type: 'textarea', rows: 3, placeholder: "Description optionnelle" } )?>
			</div>
			<div class="mb-3">
				<?-image.getFormField( 'agreement', "Vous attestez que la photos communiquée a été prise sans que vous ayez eu à pénétrer dans une propriété privée; ou que - si c'est le cas - celle-ci a été réalisée avec le consentement du propriétaire concerné. Par ailleurs, vous attestez que vous êtes bien l'auteur de cette photo ou que vous disposez des droits vous permettant de la transmettre, et vous nous autorisez à la publier et la communiquer, sans avoir à préciser qui en est l'auteur.", { type: 'boolean' } )?>
			</div>

		</div>
	</div>

	<hr class="invisible" />
	<hr class="invisible" />
	<div id="app-toolbar">
		<hr class="mt-0 mb-0" />
		<div class="container py-2">
			<? if( image.collection ) { ?>
				<div class="row">
					<div class="col">
						<a href="#delete-modal" class="btn btn-dark" data-toggle="modal"><i class="fa fa-trash"></i></a>
					</div>
					<div class="col text-right">
						<button type="submit" class="btn btn-red"><i class="fa fa-check"></i> Enregistrer</button>
					</div>
				</div>
			<? } else { ?>
				<div class="text-center"><button type="submit" class="btn btn-green"><i class="fa fa-plus"></i> Ajouter la photo</button></div>
			<? } ?>
		</div>
	</div>
</form>



<? if( image.collection ) { ?>
	<div class="modal" id="delete-modal">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-body">
					Confirmez la suppression de la photo
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-dark" data-dismiss="modal">Annuler</button>
					<button type="button" class="btn btn-red js-delete-image">Supprimer</a>
				</div>
			</div>
		</div>
	</div>
<? } ?>

